module.exports = __webpack_public_path__ + "img/instant-messaging.a78879fe.webp";